import ListThemes from './ListThemes';
import { ReactComponent as RemoveIcon } from '../Icons/Cancel.svg';
import Checkbox from '../Checkbox/Checkbox';

const ListItem = ({
    disabled,
    selected,
    label,
    value,
    desc,
    theme,
    onRemove,
    onClick = () => {},
    onCheck = () => {},
    checkable,
    iconLeft,
    iconRight,
    onIconLeftClick,
    onIconRightClick,
    className
}) => {
    const colorMapper = ListThemes[theme] || ListThemes.Light;
    const IconLeft = iconLeft;
    const IconRight = iconRight;

    const calcIconColor = () => {
        if (disabled) return colorMapper.iconDisabled;
        if (selected) return colorMapper.iconSelected;
        return colorMapper.icon;
    };

    const calcLabelColor = () => {
        if (disabled) return 'text-sf-gray-400';
        if (selected && !checkable) return `text-${colorMapper.colorSelected}`;
        return `text-${colorMapper.color}`;
    };

    return (
        <div
            className={`flex text-13 px-2 font-sf w-full ${
                !checkable && selected
                    ? `bg-${colorMapper.backgroundSelected} text-${colorMapper.colorSelected}`
                    : `bg-${colorMapper.background}`
            } items-center rounded-lg  hover:bg-${colorMapper.backgroundHover} ${
                disabled ? `bg-${colorMapper.backgroundDisabled} text-${colorMapper.colorDisabled}` : ''
            }${className}`}>
            <div
                className={`${
                    !checkable ? (disabled ? 'cursor-not-allowed' : 'cursor-pointer') : ''
                } flex w-full box-content items-center justify-between ${desc ? 'min-h-10' : 'min-h-8'}`}>
                <div className={`flex items-center`}>
                    {checkable && (
                        <div className="pr-2">
                            <Checkbox
                                disabled={disabled}
                                checked={selected}
                                name={'checkbox_' + label}
                                id={'checkbox_' + label}
                                onChange={() => onCheck(value)}
                            />
                        </div>
                    )}
                    {IconLeft && (
                        <IconLeft
                            onClick={() => (onIconLeftClick ? onIconLeftClick(value) : onClick(value))}
                            className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} box-content pr-2 h-4 w-4`}
                            fill={calcIconColor()}></IconLeft>
                    )}
                </div>
                <div className={`flex w-full items-center`}>
                    <div
                        onClick={!checkable && !disabled ? () => onClick(value) : () => {}}
                        className={`text-pretty w-full flex flex-col ${
                            !checkable ? (disabled ? 'cursor-not-allowed' : 'cursor-pointer') : ''
                        }  justify-center`}>
                        <div className={`py-0.5 ${calcLabelColor()}`}>{label}</div>
                        <div
                            className={disabled ? 'text-12 text-sf-gray-400' : `text-12 text-${colorMapper.descColor}`}>
                            {desc}
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-end">
                    {IconRight && (
                        <IconRight
                            onClick={() => onIconRightClick(value)}
                            className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} box-content ${
                                onRemove ? 'pr-2' : ''
                            } h-4 w-4`}
                            fill={calcIconColor()}></IconRight>
                    )}
                    {onRemove && (
                        <RemoveIcon
                            onClick={() => onRemove(value)}
                            className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} box-content h-4 w-4`}
                            fill={calcIconColor()}></RemoveIcon>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ListItem;
